module.exports = __webpack_public_path__ + "static/media/iconSepultura1.1e1118f8.svg";